import {PassOnLogInterface} from '../data.types';

export class PassOnLog implements PassOnLogInterface {
    constructor(
        public id: number = null,
        public checked: boolean = false,
        public buildingId: number = null,
        public building: number = null,
        public buildingName: string = '',
        public announcement: string = '',
        public subject: string = '',
        public startDate: string = '',
        public endDate: string = '',
        public createdBy: any = '',
        public createdAt: string = '',
        public passOnLogNumber: string = '',
        public status: string = '',
        public markAsRead: any = null,
        public readers: Array<any> = [],
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public importedAt: string = '',
        public formFields = {
            building: {editMode: false},
            subject: {editMode: false},
            announcement: {editMode: false},
            startDate: {editMode: false},
            endDate: {editMode: false},
            status: {editMode: false}
        },
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/PassOnLog.ts